/**
 * Breadcrumb.
 * @format
 */
import React, { useContext } from 'react';
import { NavigationContext } from '@context/navigation-context';
import { NavigationData } from '@context/navigation-context-modals';

interface TermProps {
  tid: number;
  label: string;
}

interface CrumbLinkProps {
  tid: number;
  name: string;
  link: string;
}

/**
 * Build Breadcrumb Array.
 * @param {*} breadcrumbs
 * @param {*} terms
 */
const buildBreadcrumbLinkArray = (
  navigationData: NavigationData,
  terms: TermProps[]
): CrumbLinkProps[] => {
  let { hdr_main_menu_vocab: breadcrumbData } = navigationData;
  const breadcrumbArray: CrumbLinkProps[] = [];

  if (breadcrumbData && terms && terms.length > 0) {
    terms.forEach((term) => {
      const { tid } = term;
      breadcrumbData?.forEach((crumb): void => {
        const { tid: crumbId, name, link, children } = crumb;
        if (tid === parseInt(crumbId, 10)) {
          const linkData = { tid, link, name };
          breadcrumbArray.push(linkData);
          breadcrumbData = children;
        }
      });
    });
  }

  return breadcrumbArray;
};

/**
 * Breadcrumb.
 */
const Breadcrumb = (): JSX.Element | null => {
  const navigationData = useContext(NavigationContext);

  if (
    window.location.pathname !== '/' &&
    window.location.pathname !== '/search' &&
    window.drupalSettings?.varian?.nodeId !== '14369' &&
    typeof window.drupalSettings?.varian !== 'undefined'
  ) {
    const { breadcrumb: terms } = window.drupalSettings.varian;
    const breadcrumbLinks: CrumbLinkProps[] = buildBreadcrumbLinkArray(
      navigationData,
      terms
    );

    if (breadcrumbLinks.length > 0) {
      return (
        <div className={`breadcrumb-wrapper`}>
          <div className={`breadcrumb-container`}>
            <ul>
              {breadcrumbLinks.map((crumb) => {
                const { tid, link, name } = crumb;
                return (
                  <li key={tid}>
                    <a data-tid={tid} href={link}>
                      {name}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      );
    }
  }
  return null;
};
export default Breadcrumb;
